/**
 * RouteOutletFallback — Skeleton según la ruta mientras carga el chunk lazy.
 * Se usa dentro de MainLayout (Outlet) para no tapar sidebar ni header móvil.
 */
import { useLocation } from "react-router-dom";
import { CajaPageSkeleton } from "./CajaPageSkeleton";
import { MainModulePageSkeleton } from "./MainModulePageSkeleton";

export function RouteOutletFallback() {
  const { pathname } = useLocation();

  if (pathname === "/caja") {
    return <CajaPageSkeleton variant="auto" />;
  }

  if (pathname.startsWith("/caja/")) {
    if (pathname.includes("/creditos")) {
      return <MainModulePageSkeleton kind="cards" />;
    }
    return <MainModulePageSkeleton kind="table" />;
  }

  if (
    pathname === "/dashboard" ||
    pathname === "/metricas" ||
    pathname.startsWith("/metricas/") ||
    pathname === "/ia"
  ) {
    return <MainModulePageSkeleton kind="metrics" />;
  }

  if (pathname === "/inventario" || pathname === "/inventario/promociones") {
    return <MainModulePageSkeleton kind="cards" />;
  }

  if (
    pathname.startsWith("/tienda/") ||
    pathname.startsWith("/personal") ||
    pathname.startsWith("/higiene") ||
    pathname.startsWith("/auditoria") ||
    pathname.startsWith("/buzon-equipo") ||
    pathname.startsWith("/mis-tareas") ||
    pathname.startsWith("/mi-") ||
    pathname.startsWith("/calificaciones")
  ) {
    return <MainModulePageSkeleton kind="table" />;
  }

  return <MainModulePageSkeleton kind="table" />;
}
